import React from 'react'
import NumberFormat from 'react-number-format'
import { mapProps } from 'recompose'
import FormTextField from './FormTextField'
import FormTextFieldInline from './FormTextFieldInline'
import { formTypeEnum } from './enum/formTypeEnum'

// Composant imbriqué, certaines fonctions de NumberFormat ont des callbacks différents de celles attendues par FormTextField du coup, on réadapte avec l'imbrication
const WrappedFormInput = mapProps(
	(
		{
			reduxProps: {
				input: {
					onFocus,
					onBlur
				},
				...others
			},
			onChange,
			value
		}: any
	) => {
		return {
			input: {
				onChange,
				onFocus,
				onBlur: () => {
					onBlur(undefined)
				},
				value
			},
			...others
		}
	}
)(FormTextField)

const WrappedFormInlineInput = mapProps(
	(
		{
			reduxProps: {
				input: {
					onFocus,
					onBlur
				},
				...others
			},
			onChange,
			value
		}: any
	) => {
		return {
			input: {
				onChange,
				onFocus,
				onBlur: () => {
					onBlur(undefined)
				},
				value
			},
			...others
		}
	}
)(FormTextFieldInline)

// Composant utilisé pour formater le nombre saisi avec séparateur de millier
const FormNumberFormatField = (reduxFormProps: any) => {
	let thousandSeparator = ''
	if (!('thousandSeparator' in reduxFormProps)) {
		thousandSeparator = ' '
	} else {
		thousandSeparator = reduxFormProps.thousandSeparator
	}

	return (
		<NumberFormat
			customInput={reduxFormProps.formType === formTypeEnum.textFieldInline ? WrappedFormInlineInput : WrappedFormInput}
			isNumericString
			onValueChange={(values) => {
				reduxFormProps.input.onChange(thousandSeparator === ' ' ? values.floatValue : values.formattedValue)
			}}
			thousandSeparator={thousandSeparator}
			reduxProps={reduxFormProps}
			value={reduxFormProps.input.value}
			allowNegative={reduxFormProps.allowNegative}
			decimalScale={reduxFormProps.decimalScale}
			suffix={reduxFormProps.suffix}
		/>
	)
}

export default FormNumberFormatField
